import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts'
import { DimensionScores } from '@/types'

interface DimensionRadarChartProps {
  dimensions: DimensionScores
  height?: number
  className?: string
}

export function DimensionRadarChart({ 
  dimensions, 
  height = 300,
  className 
}: DimensionRadarChartProps) {
  const data = [
    {
      dimension: 'Legal',
      score: dimensions.legal.score,
      fullMark: 100
    },
    {
      dimension: 'Financial',
      score: dimensions.financial.score,
      fullMark: 100
    },
    {
      dimension: 'Operational',
      score: dimensions.operational.score,
      fullMark: 100
    },
    {
      dimension: 'Market',
      score: dimensions.market.score,
      fullMark: 100
    }
  ]

  return (
    <div className={className}>
      <ResponsiveContainer width="100%" height={height}>
        <RadarChart data={data}>
          <PolarGrid 
            stroke="#e5e7eb" 
            className="dark:stroke-gray-600"
          />
          <PolarAngleAxis 
            dataKey="dimension" 
            tick={{ 
              fontSize: 12, 
              fill: '#6b7280' 
            }}
            className="dark:fill-gray-400"
          />
          <PolarRadiusAxis 
            angle={90} 
            domain={[0, 100]} 
            tick={{ 
              fontSize: 10, 
              fill: '#9ca3af' 
            }}
            className="dark:fill-gray-500"
          />
          <Radar
            name="Score"
            dataKey="score"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.1}
            strokeWidth={2}
            dot={{ 
              r: 4, 
              fill: '#3b82f6' 
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  )
}